// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__DPe-t","headerIcon":"header_headerIcon__3mj1C","headerText":"header_headerText__l79bP"};